import React, { useState } from 'react';
import './interactive.css';

const INITIAL_EVENTS = [
  { time: '14:20:12', level: 'ok', msg: '[Wazuh Agent] Systeemintegriteit geverifieerd op proxy-01 (Hash match)' },
  { time: '14:21:45', level: 'info', msg: '[Firewall] Inkomende HTTPS handshake geaccepteerd vanaf 185.14.22.x:443' },
  { time: '14:23:01', level: 'ok', msg: '[Checkmk] CPU load average 0.32, RAM 42% - Alle 14 host checks groen' }
];

const SecurityConsole = () => {
  const [events, setEvents] = useState(INITIAL_EVENTS);
  const [isAuditing, setIsAuditing] = useState(false);

  const handleSimulateScan = () => {
    setIsAuditing(true);
    const newAlerts = [
      { time: new Date().toLocaleTimeString(), level: 'warn', msg: '[Nmap Audit] Snelle TCP SYN scan gedetecteerd op poorten 22, 80, 443, 8080' },
      { time: new Date().toLocaleTimeString(), level: 'alert', msg: '[Firewall UFW] Onbevoegde poort 8080 geblokkeerd en IP tijdelijk gedropt' },
      { time: new Date().toLocaleTimeString(), level: 'ok', msg: '[SIEM Alert] Incident automatisch geclassificeerd als Low/Mitigated. Rapport opgeslagen.' }
    ];
    setTimeout(() => {
      setEvents(prev => [...newAlerts, ...prev]);
      setIsAuditing(false);
    }, 600);
  };

  const handleRunCisAudit = () => {
    setIsAuditing(true);
    const newAudit = [
      { time: new Date().toLocaleTimeString(), level: 'info', msg: '[CIS Benchmark] Uitvoeren hardening audit op Red Hat / Linux kernel...' },
      { time: new Date().toLocaleTimeString(), level: 'ok', msg: '[CIS Resultaat] SSH root login: DISABLED | Core dumps: DISABLED | UMask: 027 (Score: 96%)' }
    ];
    setTimeout(() => {
      setEvents(prev => [...newAudit, ...prev]);
      setIsAuditing(false);
    }, 700);
  };

  return (
    <div className="interactive-box">
      <div className="interactive-header">
        <div className="interactive-title">
          <i className="fas fa-shield-alt" style={{ color: '#ef4444' }}></i> SIEM & Enterprise Monitoring Console (Wazuh & Checkmk)
        </div>
        <div style={{ fontSize: '0.78rem', color: 'var(--text-color)' }}>TOGAF Enterprise Architecture</div>
      </div>

      <div className="interactive-content">
        <p style={{ fontSize: '0.84rem', color: 'var(--text-color)', margin: '0 0 1rem 0' }}>
          Realtime SIEM auditlogs en automatische detectie van netwerkdreigingen via Wazuh EDR agents en Checkmk infrastructure monitoring:
        </p>

        <div style={{ display: 'flex', gap: '0.6rem', marginBottom: '1rem', flexWrap: 'wrap' }}>
          <button 
            type="button" 
            className="ansible-btn" 
            style={{ padding: '0.35rem 0.85rem', fontSize: '0.78rem' }}
            onClick={handleSimulateScan}
            disabled={isAuditing}
          >
            <i className="fas fa-search"></i> Simuleer Port Scan & Detectie
          </button>
          <button 
            type="button" 
            className="ansible-btn ansible-btn--secondary" 
            style={{ padding: '0.35rem 0.85rem', fontSize: '0.78rem' }}
            onClick={handleRunCisAudit}
            disabled={isAuditing}
          >
            <i className="fas fa-clipboard-check"></i> CIS Benchmark Hardening Check
          </button>
        </div>

        <div className="security-console">
          {events.map((e, idx) => (
            <div key={idx} className="sec-event">
              <span className="sec-time">[{e.time}]</span>
              <span className={`sec-level--${e.level}`}>
                {e.msg}
              </span>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default SecurityConsole;
